(function( document, $ ){
	'use strict';

	window.Starter = window.Starter || {};

	var Extra = {
		initExtra: function() {
			this.affix();
			this.collapse();
			this.cartinput();
			this.parallax();
			this.headerslide();
			this.menu();
			this.scroll();
			this.getSlick();
		},
		affix: function() {
			var affixElement = $('.vc-header-desktop'),
				height = $('.vc-header-desktop').outerHeight(),
				wrapper = $('<div></div>');
    		
    		$('.vc-header-desktop').before(wrapper);

			$(window).on('scroll', function (event) {
				var scrollValue = $(window).scrollTop(),
					top = affixElement.outerHeight();

				if (scrollValue > top) {
					if (! affixElement.hasClass('affix') ) {
						affixElement.addClass('affix');
						wrapper.height(height);
					}
				} else{
					if ( affixElement.hasClass('affix') ) {
						affixElement.removeClass('affix');
						wrapper.height('0');
					}
				}
			});
		},
		collapse: function() {
			// $('.entry-more').on('click', '.card-header a', function(event){
			// 	event.preventDefault();
			// 	var _this = $(this);
			// 	_this.closest('.card-header').find('.fa').toggleClass('vc-icon-add');
			// 	_this.closest('.card').siblings().find('.fa').removeClass('vc-icon-add');
			// });
		},
		cartinput: function() {
			var parseNumber = function(number, def) {
				number = parseFloat(number);
				return number ? number : def;
			}

			$('input[type="number"]').each(function() {
				var $input = $(this);
				var $inputNumber = $input.closest('.input-number');

				// Append wrapper and button.
				if (! $inputNumber.length) {
					$input.wrap('<div class="input-number"></div>');

					$inputNumber = $input.closest('.input-number');
					$inputNumber.append('<button class="number-act number-inc"><i class="fa fa-plus"></i></button><button class="number-act number-dec"><i class="fa fa-minus"></i></button>');
				}

				// Number actions.
				var step = parseNumber($input.attr('step'), 1);

				// Handler actions.
				$inputNumber.find('.number-act').on('click', function(e) {
					e.preventDefault();
					var number = parseNumber($input.val(), 0);

					if ($(this).hasClass('number-inc')) {
						number += step;
					} else {
						number -= step;
						if ( 0 > number ) {
							number = 0;
						}
					}

					$input.val(number);
					$input.trigger('change');
					$input.closest('form').find('input[type="submit"]').prop('disabled', false);
				});
			});
		},
		parallax: function() {
			$('[data-init="slick"]').on('init', function(event){
				$('.parallax-window').each(function(index, el) {
					var $el = $(this);
					var test = {
							imageSrc: '',
							spead: '0.6'
						};
					var settings = $.extend(test, $el.data());
					$el.parallax(settings);
				});

			})
		},
		headerslide: function() {
			$('.vc-header-slide__left').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				draggable: false,
				prevArrow: '<button class="vc-slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fa fa-chevron-left"></i></button>'
			});

			$('.vc-header-slide__right').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				draggable: false,
				initialSlide: 3,
				nextArrow: '<button class="vc-slick-next slick-arrow" aria-label="next" type="button" style=""><i class="fa fa-chevron-right"></i></button>'
			});

			$('.vc-header-slide__left').on('click', '.vc-slick-prev', function(event) {
				event.preventDefault();
				$('.vc-header-slide__right').slick('slickPrev');
			});

			$('.vc-header-slide__right').on('click', '.vc-slick-next', function(event) {
				event.preventDefault();
				$('.vc-header-slide__left').slick('slickNext');
			});
		},
		menu: function() {
			$('.vc-menu-icon').on('click', function(event){
				event.preventDefault();
				var _this = this;
				var $this = $(this);
				$this.closest('.vc-header-mobile').find('.vc-menu-wrap').slideToggle();
				$this.find('.fa').toggleClass('vc-close');
			});
			$( '.vc-header-mobile' ).tl_menu_mobile();
		},
		scroll: function() {
			$('.scroll-btn').hide();
				$(window).scroll(function () {
					if ($(this).scrollTop() > 100) {
						$('.scroll-btn').fadeIn();
					} else {
						$('.scroll-btn').fadeOut();
					}
				});
				$('.scroll-btn').click(function () {
					$('body,html').animate({
					scrollTop: 0
				}, 800);
				return false;
			});
		},
		// Slick slider
		getSlick: function() {
			$('[data-init="vcslick"]').each(function (){
				var el = $(this);

				var breakpointsWidth = {tn: 319, xs: 479, ss: 519, sm: 767, md: 991, lg: 1199};

				var slickDefault = {
					// fade: true,
					infinite: true,
					autoplay: true,
					pauseOnHover: true,
					speed: 1000,
					adaptiveHeight: true,

					slidesToShow: 1,
					slidesToScroll: 1,

					mobileFirst: true,
					prevArrow: '<button class="vc-slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fa fa-chevron-left"></i></button>',
					nextArrow: '<button class="vc-slick-next slick-arrow" aria-label="next" type="button" style=""><i class="fa fa-chevron-right"></i></button>'

				};

				// Merge settings.
				var settings = $.extend(slickDefault, el.data());
				delete settings.init;

				// Build breakpoints.
				if (settings.breakpoints) {
					var _responsive = [];
					var _breakpoints = settings.breakpoints;

					var buildBreakpoints = function (key, show, scroll) {
						_responsive.push({
							breakpoint: breakpointsWidth[key],
							settings: {
								slidesToShow: parseInt(show),
								slidesToScroll: 1
							}
						});
					};

					if (typeof _breakpoints === "object") {
						$.each(_breakpoints, buildBreakpoints);
					}

					delete settings.breakpoints;
					settings.responsive = _responsive;
				};

				el.slick(settings);
			 });
		},
	};

	// Extend Starter method.
	$.extend(true, Starter, Extra);

	$(document).ready(function(){
		// Run.
		Starter.initExtra();
	});	

})( document, jQuery );
 


// WEBPACK FOOTER //
// ./resources/assets/scripts/components/main.js